import {
  BOOKING,
  BOOKING_LIST,
  EMP,
  CANCEL_BOOKING,
  CREATE_BOOKING,
  DESTINATION,
  SETTINGS,
  UPLOAD_DOCUMENTS,
  API_VERSION,
} from "./constants";
import { http } from "./httpServices";

export function fetchEmployeeBookingList(page,search='') {
  let limit = 10;
  return http.get(API_VERSION + BOOKING + BOOKING_LIST, {
    params: {
      limit,
      page,
      search
    },
  });
}

export function empBookingId(id) {
  return http.get(`${API_VERSION}${BOOKING}${EMP}/${id}`);
}

export function fetchDestination(depAirPortCode) {
  return http.get(`${API_VERSION}${BOOKING}${DESTINATION}`, {
    params: {
      depAirPortCode,
    },
  });
}

export function createBooking(data) {
  return http.post(API_VERSION + BOOKING + CREATE_BOOKING, data);
}
export function cancelBooking(id, data) {
  return http.put(`${API_VERSION}${BOOKING}${CANCEL_BOOKING}/${id}`, data);
}

export function getDropdownsForReason() {
  return http.get(`${API_VERSION}${SETTINGS}`, {
    params: {
      type: "cms",
    },
  });
}

export function getPerdiemData(params) {
  return http.get(`${API_VERSION}/businesstrip/perdiem`, {
    params: {
      ...params,
    },
  });
}

export function getLeaveDetails(params) {
  return http.get(`${API_VERSION}/businesstrip/leaveDetails`, {
    params: {
      ...params,
    },
  });
}

export const uploadDocuments = (data) => {
  const formData = new FormData();
  formData.append("file", data);
  return http.post(API_VERSION + SETTINGS + UPLOAD_DOCUMENTS, formData);
};

export const getCompanyList = () => {
  return http.get(`${API_VERSION}${"/companycredit"}${"/emp-list"}`);
};

export const getCostCenter = (companyCode) => {
  return http.get(`${API_VERSION}/businesstrip/getCostCenterDetails`, {
    params: {
      companyCode,
    },
  });
};

export const getProjectId = (profitCenter) => {
  return http.get(`${API_VERSION}/businesstrip/getProjectIdDetails`, {
    params: {
      profitCenter,
    },
  });
};


export const getApproversList = (wfRequestId) => {
  return http.get(`${API_VERSION}/businesstrip/leaveApproverDetails`, {
    params: {
      wfRequestId,
    },
  });
};
